import React from 'react';
import PropTypes from 'prop-types';
import { Doughnut as Chart } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	ArcElement,
	Tooltip,
	Legend
} from 'chart.js';
import { Header } from 'semantic-ui-react';

ChartJS.register(
	ArcElement,
	Tooltip,
	Legend
);

ChartJS.overrides.doughnut.plugins.legend.display = false;

const Doughnut = ( {
	data = {},
	description,
	label
} ) => {
	return (
		<>
			<Header textAlign="center">
				{ label }
			</Header>
			<div
				style={ {
					height: '250px',
					minWidth: '300px'
				} }
			>
				<Chart
					data={ data }
					options={ {
						aspectRatio: 1,
						maintainAspectRatio: false,
						responsive: true
					} }
				/>
			</div>
			<Header
				sub
				textAlign="center"
			>
				{ description }
			</Header>
		</>
	);
};

Doughnut.propTypes = {
	data: PropTypes.object,
	description: PropTypes.string,
	label: PropTypes.string
};

export default Doughnut;
